var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.orderInPreview)?_c('b-sidebar',{attrs:{"visible":_vm.orderInPreview != null,"id":"order-sidebar","title":'Comanda ' + _vm.orderInPreview,"backdrop":"","shadow":"","right":"","no-header":"","width":"900px"}},[_c('OrderViewDetails',{attrs:{"order-id":_vm.orderInPreview}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }